import { render, staticRenderFns } from "./ContentTemplates.vue?vue&type=template&id=607b68b5&"
import script from "./ContentTemplates.vue?vue&type=script&lang=js&"
export * from "./ContentTemplates.vue?vue&type=script&lang=js&"
import style0 from "./ContentTemplates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports